import { Psychologist } from "utils/interfaces"
import { APP_PAGE_URL } from "utils/env-management"
import { Text } from "ui-kit/components-branded/Text"

const renderList = (items: { id: number; slug: string | null; name: string }[]) =>
    items.map((item) =>
        item.slug ? (
            <li key={item.id}>
                <a
                    href={`${APP_PAGE_URL}/psychologists/${item.slug}`}
                    className="color-black-2 is-underlined"
                >
                    {item.name}
                </a>
            </li>
        ) : null
    )

export function SimilarCategories({ psy }: { psy: Psychologist }) {
    return {
        title: <>Хочу подобрать похожего психолога</>,
        content: (
            <>
                <p className="mb-3">
                    Вы&nbsp;можете подобрать похожего психолога по&nbsp;одному из&nbsp;следующих
                    параметров:
                </p>
                <Text isAccent>Специализация</Text>
                <ul>{renderList(psy.competences)}</ul>
                <br />
                <Text isAccent>Метод</Text>
                <ul>{renderList(psy.methods)}</ul>
                <br />
                <Text isAccent>Город</Text>
                <ul>
                    <li>
                        <a
                            href={`${APP_PAGE_URL}/psychologists/${psy.new_city.slug}`}
                            className="color-black-2 is-underlined"
                        >
                            {psy.new_city.name}
                        </a>
                    </li>
                </ul>
            </>
        ),
    }
}
